module.exports = __webpack_public_path__ + "media/dog_mp4.99dfef4f.mp4";